<template>
    <div>
        <div class="TrustAdvisorDetail-title">
            <Breadcrumb>
                <BreadcrumbItem to="/monitor/trustAdvisor">TrustAdvisor</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <Row class="demo-spin-container">
            <Col span="24">
                <Card>
                    <Row :gutter="16">
                        <Col span="2">
                        	<Row>
                        		<Col>{{$t('TrustAdvisor.generalSuggestion')}}</Col>
                        		<Col style="font-size: 20px;">{{suggestNumber}}</Icon></Col>
                        	</Row>
                        </Col>
                        <Col span="10">
                        	<Row>
                        		<Col>{{$t('TrustAdvisor.sortedSuggestion')}}</Col>
                        		<!-- 进度条 -->
                                <Row>
                                    <Col span="24">
                                        <div id="highAvailability" style="width:100%;height: 50px;"></div>
                                    </Col>
                                </Row>
                        		<Row>
                        			<Col span="8">
                        				<span>{{highNumber}}</Icon></span> {{$t('TrustAdvisor.greatestInfluence')}}
                        			</Col>
                        			<Col span="8">
                        				<span>{{mediumNumber}}</Icon></span> {{$t('TrustAdvisor.mediumInfluence')}}
                        			</Col>
                        			<Col span="8">
                        				<span>{{lowNumber}}</Icon></span> {{$t('TrustAdvisor.lowestInfluence')}}
                        			</Col>
                        		</Row>
                        	</Row>
                        </Col>
                        <Col span="6">
                        	<Row>
                        		<Col>{{$t('TrustAdvisor.influencedResources')}}</Col>
                        		<Col style="font-size: 20px;">{{affectedResourcesNumber}}</Icon></Col>
                        	</Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Spin fix v-if="spinShow" size="large"></Spin>
        </Row>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="checkItemsData" style="width: 100.1%;" :loading="affectedLoading">
        	<template slot-scope="{row,index}" slot="detail">
                <Button type="info" size="small" @click="affectedResourcesDetail(row);">{{$t('TrustAdvisor.detail')}}</Button>
            </template>
        </Table>
    </div>
</template>

<script>
    export default {
        name: 'TrustAdvisorDetail',
        data(){
            return {
                chartHighAvailability:'',
            	spinShow:true,
            	affectedLoading:false,
            	suggestNumber:'',
            	highNumber:'',
            	mediumNumber:'',
            	lowNumber:'',
            	affectedResourcesNumber:'',
                columns: [
                {
                    title: this.$t('TrustAdvisor.influence'),
                    key: 'affected'
                },
                {
                    title: this.$t('TrustAdvisor.explanation'),
                    key: 'description',
                    width:700,
                    render:(h,params)=>{
                        return h('div',{
                            domProps:{
                                innerHTML:params.row.description
                            }
                        })
                    }
                },
                {
                    title: this.$t('TrustAdvisor.influencedResources'),
                    key: 'affectedResources'
                },
                {
                    title: this.$t('TrustAdvisor.updateTime'),
                    key: 'updateTime',
                    width:150
                },
                {
                    title: this.$t('TrustAdvisor.detail'),
                    slot: 'detail'
                }],
                checkItemsData:[]
            }
        },
        mounted () {
            this.checkAWSTrustedAdvisorDetailByType();
            // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartHighAvailability.resize();
            });
        },
        methods: {
            /******************所有图表********************************/
            init:function(){
                this.highAvailabilityLine();
            },
            /*************图表*****************************/
            // 高可用性
            highAvailabilityLine:function(){
                this.chartHighAvailability=this.$echarts.init(document.getElementById("highAvailability"));
                this.chartHighAvailability.setOption({
                    grid: {
                        x:0, // 左间距
                        y: 0, // 上间距
                        x2: 10, // 右间距
                        y2: 0, // 下间距
                        containLabel: true 
                    },
                    color: ['#cc0000', '#e07700', '#009933'],   
                    // X轴
                    xAxis: {
                        type: 'value', 
                        axisTick: {
                            show: false 
                        },
                        axisLine: { 
                            show: false 
                        },
                        splitLine: {
                            show: false 
                        },
                        axisLabel: {
                            show: false 
                        }
                    },
                    yAxis: [
                        {
                            type: 'category', 
                            axisTick: {
                              show: false 
                            },
                            axisLine: { 
                                show: false, 
                                lineStyle: { 
                                    color: '#cdd3ee'
                                }
                            },
                            splitLine: {
                                show: false
                            },
                            axisLabel: {
                                show: false, 
                                fontSize: 2, 
                                color: '#cdd3ee', 
                                formatter: '{value}'
                            },
                            data: [this.$t('TrustAdvisor.influence')] 
                        }
                    ],
                    // 系列列表
                    series: [
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            itemStyle: {
                                barBorderRadius: [10, 0, 0, 10]
                            },
                            data: [this.highNumber]
                        },
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            data: [this.mediumNumber]
                        },
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            itemStyle: {
                                barBorderRadius: [0, 10, 10, 0] 
                            },
                            data: [this.lowNumber]
                        }
                    ]
                })
            },
            // 查询TrustedAdvisor的统计详情
            checkAWSTrustedAdvisorDetailByType:function(){
            	this.affectedLoading=true;
                this.$api.trustedAdvisor.checkAWSTrustedAdvisorDetailByType({
                    "accountId":this.$route.query.accountId,
                    "type":this.$route.query.type
                })
                .then(res => {
                	this.spinShow=false;
                	this.affectedLoading=false;
                    if(res.data.suggestNumber||res.data.highNumber||res.data.mediumNumber||res.data.lowNumber||res.data.affectedResourcesNumbe||res.data.checkItems){
                       // 总体建议
                        this.suggestNumber=res.data.suggestNumber;
                        // 影响最大
                        this.highNumber=res.data.highNumber;
                        // 中等程度的影响
                        this.mediumNumber=res.data.mediumNumber;
                        // 影响最小
                        this.lowNumber=res.data.lowNumber;
                        // 受影响的资源
                        this.affectedResourcesNumber=res.data.affectedResourcesNumber;
                        // 检查项
                        this.checkItemsData=res.data.checkItems;
                        this.init();
                    }
                	
                    
                })
            },
            // 查看
            affectedResourcesDetail:function(row){
            	this.$router.push({path:'/monitor/affectedResourcesDetail/',query: {id: row.id,accountId:this.$route.query.accountId,type:this.$route.query.type,name:this.$route.query.name}});
            }
        }
    }
</script>

<style scoped>
    .TrustAdvisorDetail-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .demo-spin-container{
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/trustAdvisor/trustAdvisor_list/TrustAdvisorDetail.vue